var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('sidebar',{attrs:{"show":!(
        _vm.isOnRoute(_vm.PROJECT_CALCULATION_PATH) ||
        _vm.isOnRoute(_vm.PROJECT_CALCULATION_BUILDING_ELEMENT_PATH) ||
        _vm.isOnRoute(_vm.PROJECT_CALCULATION_ENVIRONMENT) ||
        _vm.isOnRoute(_vm.PROJECT_CALCULATION_PRICE_UPDATE_PATH)
      )}}),_c('project-nav'),_c('v-slide-x-transition',[_c('router-view')],1),(_vm.isOnRoute(_vm.PROJECT_CALCULATION_PATH))?_c('status-footer'):_vm._e(),_c('ko-snackbar'),_c('ko-error-modal'),_c('welcome-modal'),_c('cookie-concent'),_c('feedback-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }